module.exports = __webpack_public_path__ + "static/img/aboutItem3.e4f2df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/aboutItem3.png
// module id = LMIx
// module chunks = 0